import React, { useState } from "react";
import { SocialIcon } from "react-social-icons";

// 🔧 PASTE YOUR GOOGLE APPS SCRIPT WEB APP URL HERE:
const GOOGLE_SHEET_URL = "https://script.google.com/macros/s/AKfycbxhzSxiQNywI2bE5rWCQPmNOc5RIEaSg3BydNcKJ1Yx6sKKZEONic9npA8aKUUp3OKNgw/exec";

export const Contact = (props) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    signUp: false,
    message: "",
  });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      await fetch(GOOGLE_SHEET_URL, {
        method: "POST",
        mode: "no-cors", // required for Google Apps Script
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          signUp: formData.signUp ? "Yes" : "No",
          message: formData.message,
          submittedAt: new Date().toLocaleString(),
        }),
      });

      setStatus("success");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        signUp: false,
        message: "",
      });
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <div id="contact">
      <div className="container">
        <div className="row">
          {/* ── Left column ── */}
          <div className="col-md-5 contact-left">
            <h2 className="contact-heading">Contact Us</h2>
            <p className="contact-subtext">
              Interested in joining or working with MedConnect? Fill out some
              info and we'll be in touch shortly, we can't wait to hear from
              you!
            </p>

            <div className="contact-social">
              <div className="contact-item">
                <SocialIcon url="www.instagram.com" bgColor="#28a745" />
                <span>&nbsp;&nbsp;{props.data ? props.data.phone : "loading"}</span>
              </div>
              <div className="contact-item">
                <SocialIcon url="www.gmail.com" bgColor="#28a745" />
                <span>&nbsp;&nbsp;{props.data ? props.data.email : "loading"}</span>
              </div>
            </div>

            {/* Campus Pulse button — kept exactly as before */}
            <div className="campuspulse-wrapper">
              <button
                className="campuspulse"
                onClick={() =>
                  window.location.href =
                    "https://umassamherst.campuslabs.com/engage/organization/medconnect"
                }
              >
                <img
                  src="img/campuspulse.png"
                  className="campuspulse"
                  alt="Campus Pulse"
                />
              </button>
            </div>
          </div>

          {/* ── Right column — form ── */}
          <div className="col-md-7 contact-form-col">
            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              {/* Name row */}
              <div className="form-name-row">
                <div className="form-group half">
                  <label htmlFor="firstName">
                    First Name <span className="required">(required)</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    placeholder=" "
                  />
                </div>
                <div className="form-group half">
                  <label htmlFor="lastName">
                    Last Name <span className="required">(required)</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    placeholder=" "
                  />
                </div>
              </div>

              {/* Email */}
              <div className="form-group">
                <label htmlFor="email">
                  Email <span className="required">(required)</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder=" "
                />
              </div>


              {/* Sign up checkbox */}
              <div className="form-group form-checkbox">
                <input
                  type="checkbox"
                  id="signUp"
                  name="signUp"
                  checked={formData.signUp}
                  onChange={handleChange}
                />
                <label htmlFor="signUp">Sign up for news and updates</label>
              </div>

              {/* Message */}
              <div className="form-group">
                <label htmlFor="message">
                  Message <span className="required">(required)</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us about yourself or ask us anything..."
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="contact-submit-btn"
                disabled={status === "sending"}
              >
                {status === "sending" ? "Sending..." : "Submit"}
              </button>

              {/* Feedback messages */}
              {status === "success" && (
                <p className="form-success">
                  ✅ Thanks! We received your message and will be in touch soon.
                </p>
              )}
              {status === "error" && (
                <p className="form-error">
                  ❌ Something went wrong. Please try again or email us directly.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};